import React, { useState, useEffect, useRef } from "react";
import { getTestcandidateCameraApi, addCameraScreenshots_API } from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";

const CameraComponent = ({ id }) => {
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [userConfirmed, setUserConfirmed] = useState(null);
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const [screenshots, setScreenshots] = useState([]);
  const [prevFrame, setPrevFrame] = useState(null);
  const [lastCaptureTime, setLastCaptureTime] = useState(0);

  useEffect(() => {
    const fetchTestCandidateData = async () => {
      try {
        const data = await getTestcandidateCameraApi(id);
        setIsCameraOn(data?.[0]?.is_camera_on || false);
      } catch (error) {
        console.error("Error fetching test candidate data:", error);
        setIsCameraOn(false);
      }
    };
    fetchTestCandidateData();
  }, [id]);

  useEffect(() => {
    if (isCameraOn && userConfirmed === null) {
      const confirmUserChoice = window.confirm(
        "This test requires access to your camera. Do you want to enable it?"
      );
      setUserConfirmed(confirmUserChoice);
      if (!confirmUserChoice) {
        navigate(-1);
      }
    }
  }, [isCameraOn, userConfirmed, navigate]);

  useEffect(() => {
    if (isCameraOn && userConfirmed && webcamRef.current) {
      const captureInterval = setInterval(() => {
        detectMovement();
      }, 1000); // Check for movement every second

      return () => clearInterval(captureInterval);
    }
  }, [isCameraOn, userConfirmed, prevFrame]);

  const detectMovement = () => {
    if (!webcamRef.current || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const video = webcamRef.current.video;

    if (video.readyState === 4) {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const currentFrame = ctx.getImageData(0, 0, canvas.width, canvas.height);

      if (prevFrame) {
        let diff = 0;
        for (let i = 0; i < currentFrame.data.length; i += 4) {
          const rDiff = Math.abs(currentFrame.data[i] - prevFrame.data[i]);
          const gDiff = Math.abs(currentFrame.data[i + 1] - prevFrame.data[i + 1]);
          const bDiff = Math.abs(currentFrame.data[i + 2] - prevFrame.data[i + 2]);
          if ((rDiff + gDiff + bDiff) > 50) {
            diff++;
          }
        }

        const now = Date.now();
        if (diff > 5000 && now - lastCaptureTime > 5000) { // Threshold & cooldown (5s)
          setLastCaptureTime(now);
          captureScreenshot();
        }
      }

      setPrevFrame(currentFrame);
    }
  };

  const captureScreenshot = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        setScreenshots((prev) => {
          const updatedScreenshots = [...prev, imageSrc].slice(-3); // Keep last 3
          return updatedScreenshots;
        });
        uploadScreenshot(imageSrc);
      }
    }
  };

  const uploadScreenshot = async (imageSrc) => {
    try {
      const formData = new FormData();
      const blob = await imageSrcToBlob(imageSrc);
      formData.append("screenshots", blob, "screenshot.jpg");

      if (screenshots.length < 3) { // Store max 3 screenshots
        await addCameraScreenshots_API(id, formData);
      }
    } catch (error) {
      console.error("Error uploading screenshot:", error);
    }
  };

  const imageSrcToBlob = (imageSrc) => {
    return fetch(imageSrc).then((res) => res.blob());
  };

  return (
    <div>
      {isCameraOn && userConfirmed && (
        <div>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ width: 200, height: 200, facingMode: "user" }}
            style={{ width: "200px", height: "200px" }}
          />
          <canvas ref={canvasRef} width={200} height={200} style={{ display: "none" }} />
        </div>
      )}
      
    </div>
  );
};

export default CameraComponent;
